export const GREEN = 'GREEN';
export const RED = 'RED';
export const GRAY = 'GRAY';
